export default __webpack_public_path__ + "static/nis2019-4462d9fd605ca60b5d1c61ca5a21f6fc.jpg";